<template>
    <Modal v-if="modalOpen" :is-card="true" :has-close-button="false" @close="closeModal">
        <template v-slot:header>
            <div class="modal__header-container">
                <h2 class="modal__header-title">{{ modalData.display_name || '' }}</h2>
                <span @click="closeModal" class="modal__header-close-btn">&#10006;</span>
            </div>
        </template>

        <template v-slot:body>
            {{ modalData.description || '' }}
        </template>
    </Modal>
</template>

<script>
import Modal from '../../../core/components/ConfiguratorModal.vue';

export default {
    components: {
        Modal,
    },
    props: {
        modalOpen: {
            type: Boolean,
            default: false,
        },
        modalData: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        },
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/online-service-booking/components/Steps/AdditionalServicesModal.vue